<div class="form-group">
  <div class="dropdown" (clickOutside)="handleClickOutside($event)">
    <label>{{ label }}</label>
    <button
      type="button"
      class="btn btn-block dropdown-toggle redesign"
      [ngClass]="{ 'is-active': isShow }"
      (click)="isOpenRoom()"
      [attr.data-qa]="qaPrefix + 'dropdown'"
    >
      <div class="d-flex flex-row">
        <section class="toggle-adults">
          <span class="mr-2 icon">
            <rx-icon name="bed"></rx-icon>
          </span>
          <span>
            {{ formatPlurals(roomAdultsArray.length, textRoomSingle, textRoomPlural) }}
          </span>
        </section>

        <section>
          <span class="mr-2 icon">
            <rx-icon [name]="totalAdult > 1 ? 'users' : 'user'"></rx-icon>
          </span>
          <span>
            {{ formatPlurals(totalAdult, textAdultSingle, textAdultPlural) }}
          </span>
        </section>
      </div>
    </button>
    <div
      class="dropdown-menu redesign"
      *ngIf="isShow"
      @collapseExpand
      [ngClass]="{ show: isShow }"
      [attr.data-qa]="qaPrefix + 'menu'"
    >
      <section class="selection_container">
        <div class="dropdown-item__redesign redesign" *ngFor="let roomData of roomAdultsArray; let i = index">
          <div class="room">
            <rx-button
              type="button"
              buttonClass="btn-remove"
              icon="rx-close"
              (click)="removeAdultRoom(roomData, i)"
              [disabled]="roomAdultsArray.length <= 1"
              [attr.data-qa]="qaPrefix + 'remove-room'"
            >
            </rx-button>
            <span class="label">{{ textRoomSingle }} {{ roomData.room }}</span>
          </div>

          <div class="adults">
            <span class="value">{{ formatPlurals(roomData.adult, textAdultSingle, textAdultPlural, true) }}</span>
          </div>

          <div class="counter">
            <span> {{ roomData.adult }}</span>
            <div class="actions">
              <div
                class="action"
                [class.disabled]="roomData.adult === 1"
                (click)="addRemoveAdult(direction.REMOVE, roomData)"
                [attr.data-qa]="qaPrefix + 'remove-adult'"
              >
                <rx-icon name="minus"></rx-icon>
              </div>
              <div class="separator"></div>
              <div
                class="action"
                [class.disabled]="roomData.adult === maxAdults && !occupancySearch()"
                (click)="addRemoveAdult(direction.ADD, roomData)"
                [attr.data-qa]="qaPrefix + 'add-adult'"
              >
                <rx-icon name="add"></rx-icon>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="dropdown-item__redesign btn-wrap" (click)="addRoom()" [attr.data-qa]="qaPrefix + 'add-room'">
        <rx-icon name="add"></rx-icon>
        <span>
          {{ textAddRoom }}
        </span>
      </div>
    </div>
  </div>
  <ng-content select="[rx-error]"></ng-content>
</div>
